import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../components/Buttons";

export const Supply = () => {
    document.title = "Alış";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Alışlar", value: "/supplies" },
        { name: "Alış", value: "/supplies/supply", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Alış</h2>
                    <p>
                        Alışlar – məhsul alışı əməliyyatlarını icra etmək üçün nəzərdə tutulub. Nümunədəki ardıcıllığa əməl edərək alış sənədini yaratmaq olar.
                        <ol>
                            <li>
                                Yeni alış sənədinə lazım olan məlumatları əlavə edərək <SaveButton /> düyməsini sıxın
                            </li>
                            <li>
                                Alış sənədi yadda saxlanıldıqdan sonra, sənədi tərk etmədən yeni sənədlər yarada bilərsiniz. Alış ilə bağlı
                                <Button>ödəniş</Button>, <Button>qaytarma</Button> və ya alınan məhsulların <Button>satış</Button> sənədlərini yarada
                                bilərsiniz. Bunun üçün <Button>Sənəd yarat</Button> düyməsini sıxıb, təqdim olunan seçimlərdən birini seçmək lazımdır
                            </li>
                            <li>
                                Yadda saxlanılmış sənədi excell formatda endirə, həm də çap edə bilərsiniz. <Button>...</Button> düyməsi ilə sənədi silmək olar.
                                Alış sənədinin <b>təyinat</b> hissəsində sənədə əlavələr edərək <SaveButton /> düyməsini sıxın
                            </li>
                        </ol>
                    </p>
                    <img src="/images/supplies/supply-1.gif" alt="Alış" />
                    <p>
                        <ol>
                            <li>
                                Məhsulları sənədə əlavə etməyin digər yolu, <Button>Məhsullar</Button> düyməsini sıxmaqla olur.
                            </li>
                            <li>
                                Bu halda açılmış pəncərədən məhsulları seçib <Button>Əlavə et</Button> düyməsini sıxmaq lazımdır. Məhsulları həmçinin sol
                                tərəfdəki qruplara görə də seçib sənədə əlavə etmək olar.
                            </li>
                        </ol>
                    </p>
                    <img src="/images/supplies/supply-2.gif" alt="Alış" />
                </article>
            </div>
        </div>
    );
};
